import React, { useContext, useState } from "react";
import { makeStyles } from "@material-ui/core/styles";
import { Box, Grid } from "@material-ui/core";
import {
  getPersistedLanguage,
  LanguageActionTypeEnum,
  LanguageDispatchContext,
  LanguageState,
} from "../../context/LanguageContext";

export const useStyles = makeStyles(
  (theme) => ({
    header: {
      backgroundColor: theme.palette.secondary.main,
      height: "100%",
      width: "100%",
    },
    ul: {
      float: "right",
      listStyleType: "none",
      padding: 0,
      margin: 0,
      overflow: "hidden",

      "& li": {
        display: "inline-flex",
        alignItems: "right",
        justifyContent: "right",

        float: "left",
        fontSize: 10,
        marginBottom: 2,
        color: "white",
        marginRight: theme.spacing(2),
        fontWeight: theme.typography.fontWeightMedium,
        cursor: "pointer",

        "&:hover": {
          textDecoration: "underline",
        },

        "&.current": {
          textDecoration: "underline",
          fontWeight: theme.typography.fontWeightBold,
        },
      },
    },
  }),
  {
    name: "language-chooser-style",
    flip: null,
  }
);

export const PrivacyPolicyScreen = (props: any) => {
  const classes = useStyles(props);
  const [contentValue, setContentValue] = useState(
    getPersistedLanguage().localeCode
  );
  const languageDispatch = useContext(LanguageDispatchContext);

  const supportedLanguages: Array<LanguageState> = [
    {
      message: "language.french",
      localeCode: "fr",
      remoteCode: "fr_FR",
    },
    {
      message: "language.english",
      localeCode: "en",
      remoteCode: "en_GB",
    },
  ];

  const switchLanguage = (locale: LanguageState) => {
    languageDispatch({
      type: LanguageActionTypeEnum.switch,
      data: locale,
    });
  };
  return (
    <>
      <Grid container className={classes.header}>
        <Grid xs={1} sm={2}>
          <Box component="ul" className={classes.ul}>
            <Box
              component="li"
              className={`${"en" === contentValue ? "current" : ""}`}
              onClick={(_) => {
                setContentValue("en");
                switchLanguage(supportedLanguages[1]);
              }}
            >
              English
            </Box>
            <Box
              component="li"
              className={`${"fr" === contentValue ? "current" : ""}`}
              onClick={(_) => {
                setContentValue("fr");
                switchLanguage(supportedLanguages[0]);
              }}
            >
              Français
            </Box>
          </Box>
        </Grid>
        <Grid container className={classes.header}>
          <iframe
            title="privacy"
            src={"privacy_" + contentValue + ".html"}
            width="100%"
          ></iframe>
        </Grid>
      </Grid>
    </>
  );
};

PrivacyPolicyScreen.routeName = "/privacy";
